module.exports = __webpack_public_path__ + "static/media/finance-feature-1.a95d5f92.svg";